import { FC } from 'react';

export const Templates: FC = () => {
  return <>Templates</>;
};
